module.exports = __webpack_public_path__ + "img/icon-card-k.202203d0.png";